export default __webpack_public_path__ + "media/images/features/local_delivery/episode4/LP_02-54968b6b026ee0df8a36b1e4be5883fd.jpg";